import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

/** MOD chưa được Admin cấp quyền (hoặc vừa bị thu quyền) gõ thẳng đường dẫn Thưởng Online. */
const NoAccess = ({ adminOnly = false }: { adminOnly?: boolean }) => {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title={adminOnly ? 'Trang này chỉ Admin dùng được' : 'Bạn chưa được cấp quyền xem Thưởng Online'}
      subTitle={adminOnly ? undefined : 'Hãy liên hệ Admin để được cấp quyền ở Thưởng Online → Chính sách → Quyền.'}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Về Tổng quan
        </Button>
      }
    />
  );
};

export default NoAccess;
